<div class="container">
  <ng-container *ngFor="let btn of actions.buttons">
    <button
      class="assistant-banner-action-button merri-common-button-bold"
      mat-stroked-button
      [style.color]="btn.color"
      [style.background-color]="btn.backColor"
      merriNoFocusLink
      (click)="onActionBtnClick(btn)"
      disableRipple
    >
      <mat-icon
        *ngIf="btn.iconPrefix"
        [svgIcon]="btn.iconPrefix"
      ></mat-icon>
      {{ btn.text }}
      <mat-icon
        *ngIf="btn.iconSuffix"
        [svgIcon]="btn.iconSuffix"
        iconPositionEnd
      ></mat-icon>
    </button>
  </ng-container>
</div>
